import { MUTATION } from '../gql-operations';

export const PENDING_PUBLISHED_FOLDER_COPY_TOKEN_KEY = 'luckynote_pending_copy_token';
export const PUBLISHED_FOLDER_ATTRIBUTION_KEY = 'luckynote_published_folder_attribution';

export const savePendingPublishedFolderCopyToken = token => {
    if (!token) {
        return;
    }

    localStorage.setItem(PENDING_PUBLISHED_FOLDER_COPY_TOKEN_KEY, token);
};

export const savePublishedFolderAttribution = (token, intent = 'view') => {
    if (!token) {
        return;
    }

    const existing = getPublishedFolderAttribution();
    localStorage.setItem(
        PUBLISHED_FOLDER_ATTRIBUTION_KEY,
        JSON.stringify({
            token,
            firstIntent: existing?.token === token ? existing.firstIntent : intent,
            lastIntent: intent,
            firstSeenAt: existing?.token === token ? existing.firstSeenAt : new Date().toISOString(),
            lastSeenAt: new Date().toISOString(),
            entryPath: existing?.token === token ? existing.entryPath : window.location.pathname,
            entrySearch: existing?.token === token ? existing.entrySearch : window.location.search
        })
    );
};

export const getPublishedFolderAttribution = () => {
    try {
        const value = localStorage.getItem(PUBLISHED_FOLDER_ATTRIBUTION_KEY);
        return value ? JSON.parse(value) : null;
    } catch (_) {
        return null;
    }
};

export const clearPublishedFolderAttribution = () => {
    localStorage.removeItem(PUBLISHED_FOLDER_ATTRIBUTION_KEY);
};

export const consumePendingPublishedFolderCopy = async apolloClient => {
    const token = localStorage.getItem(PENDING_PUBLISHED_FOLDER_COPY_TOKEN_KEY);

    if (!token) {
        return null;
    }

    localStorage.removeItem(PENDING_PUBLISHED_FOLDER_COPY_TOKEN_KEY);

    const result = await apolloClient.mutate({
        mutation: MUTATION.COPY_PUBLISHED_FOLDER,
        variables: {
            data: { token }
        }
    });

    return result?.data?.copyPublishedFolder?.folder || null;
};
